$(document).ready(function () {
    if (!navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) && ($(".module-footermenu-list .nice-select").length > 0 || $(".module-dropdown .nice-select").length > 0)) {
        var li = $(".module-footermenu-list .nice-select > ul > li, .module-dropdown .nice-select > ul > li");

        li.click(function () {
            window.open($(this).attr("value"), $(this).attr("data-target"));
        });

        li.keypress(function (e) {
            if (e.which == 13) {
                window.open($(this).attr("value"), $(this).attr("data-target"));
            }
        });
    } else if ($(".module-footermenu-list select").length > 0 || (".module-dropdown select").length > 0) {
        var select = $(".module-footermenu-list select, .module-dropdown select");
        select.change(function () {
            window.location.replace($(this).val());
        });
    }
});